/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const ContractWithPenIconOutline = createIcon({
  displayName: 'ContractWithPenIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M9 21h-4l-8.74228e-08-3.55271e-15c-1.10457-4.82823e-08-2-.895431-2-2 0 0 0 0 0 0v-14l2.30926e-14 3.01992e-07c-1.66785e-07-1.10457.89543-2 2-2h12l-8.74228e-08 1.77636e-15c1.10457-4.82823e-08 2 .89543 2 2v3"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 21l2.624-.324 2.91996e-08-3.61096e-09c.184615-.0228304.356343-.106583.488-.238l6.358-6.358 9.65443e-08-9.61337e-08c.704214-.701219.7069-1.84047.00599981-2.545l-.006-.005v0l7.5457e-08 7.57792e-08c-.701219-.704214-1.84047-.7069-2.545-.00600015v.006l-6.3 6.3 -4.9364e-08 4.90309e-08c-.128161.127296-.21106.293094-.236.472Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8 17v0h-6.55671e-08c-.828427-3.62117e-08-1.5-.671573-1.5-1.5 0 0 0-1.77636e-15 0-1.77636e-15v0l1.5099e-14-1.60927e-07c1.25089e-07-.828427.671573-1.5 1.5-1.5h-1.60927e-07l-6.55671e-08 1.77636e-15c.828427-3.62117e-08 1.5.671573 1.5 1.5v0l1.77636e-15 6.55671e-08c0 .828427-.671573 1.5-1.5 1.5 -2.03192e-08 0-4.52479e-08-3.55271e-15-6.55671e-08-3.55271e-15Z"
        ></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M6.5 7h8"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.5 10.5h4"
        ></path>
      </g>
    </>
  ),
})

const ContractWithPenIconTwoTone = createIcon({
  displayName: 'ContractWithPenIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M9 21h-4l-8.74228e-08-3.55271e-15c-1.10457-4.82823e-08-2-.895431-2-2 0 0 0 0 0 0v-14l2.30926e-14 3.01992e-07c-1.66785e-07-1.10457.89543-2 2-2h12l-8.74228e-08 1.77636e-15c1.10457-4.82823e-08 2 .89543 2 2v3"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 21l2.624-.324 2.91996e-08-3.61096e-09c.184615-.0228304.356343-.106583.488-.238l6.358-6.358 9.65443e-08-9.61337e-08c.704214-.701219.7069-1.84047.00599981-2.545l-.006-.005v0l7.5457e-08 7.57792e-08c-.701219-.704214-1.84047-.7069-2.545-.00600015v.006l-6.3 6.3 -4.9364e-08 4.90309e-08c-.128161.127296-.21106.293094-.236.472Z"
        ></Box>
        <Box
          as="path"
          stroke="twoToneFillColor"
          fill="twoToneLightColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8 17v0h-6.55671e-08c-.828427-3.62117e-08-1.5-.671573-1.5-1.5 0 0 0-1.77636e-15 0-1.77636e-15v0l1.5099e-14-1.60927e-07c1.25089e-07-.828427.671573-1.5 1.5-1.5h-1.60927e-07l-6.55671e-08 1.77636e-15c.828427-3.62117e-08 1.5.671573 1.5 1.5v0l1.77636e-15 6.55671e-08c0 .828427-.671573 1.5-1.5 1.5 -2.03192e-08 0-4.52479e-08-3.55271e-15-6.55671e-08-3.55271e-15Z"
        ></Box>
        <Box
          as="path"
          stroke="twoToneLightColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.5 7h8"
        ></Box>
        <Box
          as="path"
          stroke="twoToneLightColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.5 10.5h4"
        ></Box>
      </g>
    </>
  ),
})

const ContractWithPen: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    case 'twoTone':
      return <CustomIcon as={ContractWithPenIconTwoTone} {...props} />
    default:
      return <CustomIcon as={ContractWithPenIconOutline} {...props} />
  }
}

export default memo(ContractWithPen)
